import toString from 'lodash-es/toString';

import { PLACEHOLDER } from '@/constants';

export default function formatValue(v?: unknown): string {
  return v || v === 0 ? toString(v) : PLACEHOLDER;
}
